// Deals widget embedz
$(function(){
        var dealToopTipOffset = {
            'mobile' : {'x': 200, 'y': 120 },
            'desktop' : {'x': 120, 'y': 120 }
        };

        // Mobile tippy-tap
        $(document).on('click', '.deals-widget-coupon-details', function(e){
                e.preventDefault();

                let p = $(this).position();
                let tip = $(this).parent().find('.deals-widget-coupon-text');
                let h = tip.height() || dealToopTipOffset.mobile.y;

                // Only move this around on our mobile breakpoints
                if( $(window).width() <= 768 ) {
                    tip.attr('data-doHide', false);
                    tip.css('top', p.top - h);
                    tip.css('left', p.left - dealToopTipOffset.mobile.x);
                }

                tip.toggle();
        });

        // Hover states For the desktop users
        $(document).on('mouseenter', '.deals-widget-coupon-details', function(e){
                if( $(window).width() > 768 ) {
                        let p = $(this).position();
                        let tip = $(this).parent().find('.deals-widget-coupon-text');
                        let h = tip.height() || dealToopTipOffset.desktop.y;

                        tip.attr('data-doHide', false);
                        tip.css('top', p.top - h);
                        tip.css('left', p.left - dealToopTipOffset.desktop.x);
                        tip.show();

                        setTimeout(function(el){
                                if(el.attr('doHide') == false){
                                        el.hide();
                                }
                        }, 1500, tip);
                }
        });

        $(document).on('mouseleave', '.deals-widget-coupon-details', function(e){
                if( $(window).width() > 768 ) {
                        let tip = $(this).parent().find('.deals-widget-coupon-text');
                        let el = e.relatedTarget.className;
                        tip.attr('data-doHide', true );

                        if( el !== 'deals-widget-coupon-text' ) {
                                tip.hide();
                        }
                }
        });

        $(document).on('mouseleave', '.deals-widget-coupon-text', function(e){
                if( $(window).width() > 768 ) {
                        $(this).hide();
                }
        });
});
